import { Workflow } from "lucide-react";
import { canAccess, roleAccess, type AccessVerb } from "@hisense/shared";
import { useAuth } from "@/app/auth";
import { SettledRules } from "@/components/ui/SettledRules";

/**
 * Quy tắc của Quy trình công đoạn — chốt 20/09/2026 theo chuẩn (gắn một bản BOM đã duyệt và chạy tuần tự, ghi rõ cơ sở thời gian,
 * điểm kiểm dự kiến, công đoạn thuê ngoài, ai được làm gì), khách bác lại được. Trước đây là bốn thẻ vàng rải trong trang sửa.
 *
 * Phần thật sự phải hỏi khách — phiếu công đoạn thật, thời gian chuẩn bị / chu kỳ, tiêu chuẩn kiểm của từng bước — là DỮ LIỆU của
 * khách, không bịa ra được; nó nằm ở mục 27 bộ câu hỏi và không chặn việc dùng màn hình.
 */
export const ROUTING_RULES_SETTLED = ["source", "timing", "qc", "subcontract", "authority"] as const;

export function RoutingRules() {
  return <SettledRules ns="routings" rules={ROUTING_RULES_SETTLED} icon={Workflow} />;
}

/** Cùng bộ giải quyền với máy chủ (ô tick menu Quy trình công đoạn) — trước 20/09/2026 trang này chặn cứng theo vai trò admin. */
export function useRoutingAccess() {
  const { user } = useAuth();
  const access = user ? user.access ?? roleAccess(user.role) : null;
  return (verb: AccessVerb) => !!access && canAccess(access, "routings", verb);
}
